<div *ngIf="dataLoaded" class="payment-details">
  <div class="payment-info">
    <span class="patient-name"
      *ngIf="canShowPatientName">{{expenses.patientName}}</span>
    <span class="total-expense">
      {{expenses.currency}} <span *ngIf="expenses.isPreloadRedemptionGroup" class="negative-amount">-</span>
      {{expenses.totalExpense | number:'1.2-2' }}
      <span *ngIf="showManualPaymentBtn && expenses.displayBankFeeCover">
        +
        {{expenses.bankFeeCoverCurrency}} {{expenses.bankFeeCover | number:'1.2-2'}} fee
      </span>
    </span>
  </div>
  <div class="payment-buttons">
    <button *ngIf="showInvestigationBtn" [disabled]="processingRequest"
      class="large-button investigation-button" (click)="automatedPaymentFailed.emit(expenses.expenses)">
      Requires Investigation
    </button>

    <button *ngIf="showCheckNmibleStatusBtn" [disabled]="processingRequest"
      class="large-button investigation-button" (click)="checkNmibleStatus.emit(expenses)">
      Check status on Nmible
    </button>

    <app-split-button
      *ngIf="showUpdateNmiblePaymentStatusManuallyBtn"
      [disabled]="processingRequest"
      [actions]="nmiblePaymentStatusActions"
      (actionSelected)="onUpdateNmiblePaymentStatusManuallySelected($event)">
    </app-split-button>

    <button *ngIf="showManualPaymentBtn" (click)="sendToFinance.emit(expenses.expenses)"
      [disabled]="processingRequest" class="send-to-finance-button">
      Switch to Manual Payment
    </button>

    <button
      *ngIf="showPayByCaxtonBankBtn"
      [disabled]="processingRequest" class="large-button pay-button" (click)="payByBank.emit(expenses.expenses)">
      <span *ngIf="processingRequest">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      </span>
      <span *ngIf="!processingRequest">Pay all by Caxton Bank</span>
    </button>

    <button
      *ngIf="showPayByCaxtonCardBtn"
      [disabled]="processingRequest" class="large-button pay-button" (click)="payByCard.emit(expenses.expenses)">
      <span *ngIf="processingRequest">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      </span>
      <span *ngIf="!processingRequest">Pay all by Caxton Card</span>
    </button>

    <button
      *ngIf="showUnloadCaxtonBtn"
      [disabled]="processingRequest" class="large-button pay-button" (click)="unloadFromCard.emit(expenses.expenses)">
      <span *ngIf="processingRequest">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      </span>
      <span *ngIf="!processingRequest">Unload all from Caxton</span>
    </button>

    <button *ngIf="showPayByNmibleBtn"
      [disabled]="processingRequest" class="large-button pay-button" (click)="payByNmible.emit(expenses.expenses)">
      <span *ngIf="processingRequest">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      </span>
      <span *ngIf="!processingRequest">Pay all by Nmible Card</span>
    </button>

    <button *ngIf="showPayByNmibleBankBtn"
      [disabled]="processingRequest" class="large-button pay-button" (click)="payByNmibleBank.emit(expenses.expenses)">
      <span *ngIf="processingRequest">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      </span>
      <span *ngIf="!processingRequest">Pay all by Nmible Bank</span>
    </button>

    @if (showRetryNmibleBtn) {
      <app-button text="Retry Nmible Payment"
                  [disabled]="processingRequest"
                  variant="info"
                  (click)="investigation.emit(expenses.expenses)" />
    }

    @if (showRetryCaxtonBtn) {
      <app-button text="Not on Caxton - Retry"
                  [disabled]="processingRequest"
                  variant="info"
                  (click)="investigation.emit(expenses.expenses)" />
    }

    @if (showFoundOnCaxtonBtn) {
      <app-button text="Found on Caxton"
                  [disabled]="processingRequest"
                  variant="info"
                  (click)="transfer.emit(expenses)" />
    }
  </div>
</div>

<div *ngIf="!dataLoaded" class="payment-details">
  <div class="payment-info">
    <div class="loaders">
      <ngx-skeleton-loader style="width: 40%;"></ngx-skeleton-loader>
      <ngx-skeleton-loader style="width: 15%;"></ngx-skeleton-loader>
    </div>
  </div>
  <div class="payment-buttons">
    <div class="loaders" *ngIf="hasWritePermission">
      <ngx-skeleton-loader style="width: 211px;" class="investigation-button-loader"
        *ngIf="selectedTab === ExpenseClaimState.Processing"></ngx-skeleton-loader>
      <ngx-skeleton-loader style="width: 211px;"
        *ngIf="selectedTab === ExpenseClaimState.AutomatedPaymentApproved"></ngx-skeleton-loader>
      <ngx-skeleton-loader style="width: 222px;" class="payment-button-loader"
        *ngIf="selectedTab === ExpenseClaimState.AutomatedPaymentApproved"></ngx-skeleton-loader>
      <ngx-skeleton-loader style="width: 160px;" class="failed-button-loader"
        *ngIf="selectedTab === ExpenseClaimState.AutomatedPaymentFailed"></ngx-skeleton-loader>
      <ngx-skeleton-loader style="width: 136px;" class="failed-button-loader"
        *ngIf="selectedTab === ExpenseClaimState.AutomatedPaymentFailed"></ngx-skeleton-loader>
    </div>
  </div>
</div>
